'use client'

import { AnimatedAccordion } from '@components/primitives/AnimatedAccordion'
import { Icon } from '@components/primitives/Icon'
import { classMerge } from '@components/utilities/classMerge'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { trackEvent } from '@lib/tracking'
import { type TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useState } from 'react'

export const AccordionSection = ({
  chevronPlacement = 'left',
  children,
  className,
  defaultOpen = false,
  title,
  trackingEvent,
}: {
  chevronPlacement?: 'left' | 'right'
  children: React.ReactNode
  className?: string
  defaultOpen?: boolean
  title: React.ReactNode
  trackingEvent?: TrackingEvents
}) => {
  const [accordionOpen, toggleAccordion] = useState<boolean>(defaultOpen)

  return (
    <div
      className={classMerge('cursor-pointer hover:bg-neutral100', className)}
      onClick={() => {
        toggleAccordion(!accordionOpen)
        trackingEvent
          ? trackEvent(trackingEvent, {
              val: title?.toString().split(' ').slice(0, 5).join('-'),
            })
          : undefined
      }}
    >
      <div
        className={classMerge(
          'flex items-center py-1',
          chevronPlacement === 'right'
            ? 'flex-row-reverse justify-between'
            : '',
        )}
      >
        <Icon
          className={classMerge(
            'cursor-pointer text-neutral600',
            accordionOpen ? 'rotate-90' : '',
            'transform transition-all duration-500',
            chevronPlacement === 'left' ? 'mr-4' : 'ml-4',
          )}
          icon={faChevronRight}
        />
        {title}
      </div>
      <AnimatedAccordion isExpanded={accordionOpen}>
        {children}
      </AnimatedAccordion>
    </div>
  )
}
